import React, { useState, useContext, } from "react";
import { Form, Row, Col, Input, Button, Select, Space, Typography, } from "antd";
import { ExclamationCircleFilled, } from '@ant-design/icons';
import { PasswordRequirements } from "../../../UI/PasswordRequirements.component";
import { isValidPassword, validatePhoneNumber, maskPhoneNumber, isValidPhoneNumber, } from "../../../../Validation";
import { createCustomer } from "../../../../services/UserService";
import { NocContext } from "../../../../context/noc-context";
import { useNotificationApi } from "../../../UI/NotificationProvider";

const { Option } = Select;
const { Text } = Typography;

export const AddNewCustomerForm = ({setDisplayAddNewCustomer, setDisplayLastPage, refreshData, setDisplaySuccessMessage, ...props}) => {

    const notificationApi = useNotificationApi();
    const [nocState, dispatchNoc] = useContext(NocContext)
    const [form] = Form.useForm();    
    const [newPassword, setNewPassword] = useState('');
    const [formErrorMessage, setFormErrorMessage] = useState();

    const onFinish = (values) => {
        createCustomer(values).then((response) => {
            if(response.status === 'success'){
                setDisplayLastPage(true);
                if(nocState?.nocList?.length < nocState.pageSize){
                    dispatchNoc({
                        type: 'ADD_CUSTOMER', 
                        payload: values,
                    })
                }
                refreshData();
                setTimeout(() => {
                    notificationApi['success']({
                        message: 'Success',
                        description: `Customer: ${values.companyName} has been successfully created.`,  
                        duration: 6,
                    });
                }, 2000)
                setDisplayAddNewCustomer(false);
            } else {
                // message.error('An error has occurred')
                setFormErrorMessage(response.message || response.error);
            }
        })
    };

    return(
        <>
            <Form 
                id='add-new-customer-form'
                form={form}
                name='add-new-customer-form'
                layout="vertical"
                autoComplete="off"
                scrollToFirstError
                onFinish={onFinish}
                labelWrap
                onValuesChange={() => setFormErrorMessage('')}
                >
                
                { formErrorMessage ? 
                        <Row style={{marginBottom: 20}}>
                            <Text type='danger'><ExclamationCircleFilled style={{marginRight: 8}}/>{formErrorMessage}</Text>
                        </Row>
                    : 
                        null
                }

                <Row gutter={[12,6]}>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item label="Company Name:" name="companyName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter company name',
                                },
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item label="Access Type:" name="accessType" 
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select access type'
                                },
                            ]}
                            >
                            <Select placeholder="Please select one">
                                <Option value={'R'}>Read</Option>
                                <Option value={'W'}>Read/Write</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item 
                            hasFeedback
                            label="Email address:" 
                            name="email"
                            rules={[
                                { 
                                    required: true, 
                                    message: 'Please enter a valid email address (for example: user@avalan.com)',
                                    type: 'email'
                                }, 
                            ]}      
                        >
                            <Input type='email'/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item label='Username:' name='username' rules={[{ required: true, }]}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item 
                            name="password" 
                            label="New Password:" 
                            hasFeedback
                            help={ 
                                (!isValidPassword(newPassword) && newPassword) && 
                                    <PasswordRequirements password={newPassword}/>
                                }
                            rules={[
                            {
                                required: true,
                                message: ''
                            },
                            () => ({
                                validator(_, value) {
                                    setNewPassword(value);
                                    if (value && isValidPassword(value)){
                                        return Promise.resolve();
                                    } 
                                    return Promise.reject();
                                    },
                                }),
                            ]}
                            >
                            <Input.Password />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item name='confirmPassword' label="Confirm Password:" dependencies={['password']} hasFeedback
                            rules={[
                                { 
                                    required: true, 
                                    message: "Please confirm new password"
                                }, 
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if(!value || getFieldValue('password') === value){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('New password does not match'))
                                    }
                                }),
                            ]}
                            >
                            <Input.Password />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item label="First Name:" name="firstName">
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item label="Last Name:" name="lastName">
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <Form.Item 
                            hasFeedback
                            label="Phone Number:" 
                            name="phone" 
                            rules={[
                                {
                                    type: "tel", 
                                    validator: (rule, value) => {
                                        if(!rule.required && !value){
                                            return Promise.resolve();
                                        }
                                        if(validatePhoneNumber(value) && isValidPhoneNumber(value)){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Please enter valid phone number'));
                                    }
                                }, 
                                ]}
                            >
                            <Input onInput={(e) => maskPhoneNumber(e) }/>
                        </Form.Item>
                    </Col>
                </Row>
    
                <Row justify="end">
                    <Form.Item noStyle>
                        <Space>
                            <Button onClick={() => setDisplayAddNewCustomer(false)}>Cancel</Button>
                            <Button type="primary" htmlType="submit">Create new customer</Button>
                        </Space>
                    </Form.Item>
                </Row>
            </Form>
        </>
    );
}